module.exports = function () {
  return new Promise(function (resolve) {
    require.ensure([], function (require) {
      resolve(require("!!/data/fp-commerce/shared-live/tmp/shop/node_modules/babel-loader/lib/index.js!/data/fp-commerce/shared-live/tmp/shop/client/generated/config.js"));
    });
  });
}


/*****************
 ** WEBPACK FOOTER
 ** ../~/promise-loader?global!./generated/config.js
 ** module id = 393
 ** module chunks = 20
 **/